import { ManualAddExceptionContainerWebComponent } from './component/ManualAddExceptionContainerWebComponent';

export { ManualAddExceptionContainerWebComponent };
